const APP_STORE_URL = 'https://apps.apple.com/us/app/the-exchange-chess/id6742661001';

// Ad registry so you can add more ads in one place
export const ADS = {
  // The Exchange | Chess ad
  exchange: function ExchangeAd({ onDismiss, secondsLeft, canClose }) {
    return (
      <div style={{ position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
        <img
          src="/TheExchangeLogo.png"  // or your imported asset
          alt="The Exchange | Chess"
          style={{ width: 42, height: 42, borderRadius: 9 }}
        />
          <div>
            <h3 style={{ margin: 0, color: 'white' }}>The Exchange | Chess</h3>
            <small style={{ opacity: 0.8 }}>Tactics • Puzzles • Social • Analysis</small>
          </div>
        </div>
        <p style={{ lineHeight: 1.4, marginTop: 8 }}>
          Enjoying Train Chess? Try <strong>The Exchange | Chess</strong>, a free app with endless free real-world puzzles and a friendly chess community. Available on iOS!
        </p>
        <div style={{ display: 'flex', gap: 10, marginTop: 12, flexWrap: 'wrap' }}>
          <a href="/theexchange" target="_blank" rel="noreferrer" style={{
            textDecoration: 'none', padding: '10px 14px', borderRadius: 8,
            background: 'var(--highlight-color, #4caf50)', color: 'white', fontWeight: 600
          }}>Learn More</a>
        </div>
        <div style={{ position: 'absolute', top: -10, right: -5 }}>
          <button
            onClick={onDismiss}
            disabled={!canClose}
            style={{
              width: 32,
              height: 32,
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.12)',
              border: '1px solid rgba(255,255,255,0.25)',
              color: 'inherit',
              fontWeight: 600,
              cursor: canClose ? 'pointer' : 'not-allowed',
              opacity: canClose ? 1 : 0.6,
            }}
          >
            {canClose ? 'X' : `${secondsLeft}`}
          </button>
        </div>
      </div>
    );
  },

  // Example placeholder for future ads (uncomment and customize)
  // newsletter: function NewsletterAd({ onDismiss }) {
  //   return (
  //     <div>
  //       <h3>Weekly Chess Tips</h3>
  //       <p>Get a short email with one actionable tactic each week.</p>
  //       <a href="/newsletter" style={{ textDecoration: 'none', padding: '10px 14px', borderRadius: 8,
  //         background: 'var(--highlight-color, #4caf50)', color: 'white', fontWeight: 600 }}>Subscribe</a>
  //       <button onClick={onDismiss} style={{ background: 'transparent', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', marginLeft: 10 }}>Not now</button>
  //     </div>
  //   );
  // },
};
